import DashboardScreen from "..";

const DashboardContainer = () => {
  return <DashboardScreen />;
};

export default DashboardContainer;
